/* ヒーロー（案B）: 16:9 を中央に大きく、左右に前後のスライドを覗かせる無限ループ。
   musee（楽天）のように隙間を空けて並べる。PC はスライド幅 84%＋隙間 10px、SP は 1枚ずつ。
   ループは前後に 2 枚ずつ複製を置き、端の複製まで進んだら transition なしで本物へ戻す。 */
if (!customElements.get('rb-hero-slider')) {
  class RbHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rb-track]');
      if (!this.track) return;
      const real = Array.from(this.track.children);
      this.n = real.length;
      this.dots = Array.from(this.querySelectorAll('[data-rb-dot]'));
      if (this.n < 2) {
        this.setAttribute('data-static', '');
        return;
      }

      this.C = 2;
      const clone = (el) => {
        const c = el.cloneNode(true);
        c.classList.add('is-clone');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a, button').forEach((a) => { a.tabIndex = -1; });
        c.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
        return c;
      };
      for (let i = 0; i < this.C; i++) {
        this.track.append(clone(real[i % this.n]));
        this.track.prepend(clone(real[(this.n - 1 - (i % this.n) + this.n) % this.n]));
      }
      this.slides = Array.from(this.track.children);
      this.index = this.C;

      this.querySelectorAll('[data-rb-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      this.querySelectorAll('[data-rb-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(this.C + i)));

      // 覗いている前後のスライドを押したら、リンクに飛ばずにそのスライドへ送る
      this.slides.forEach((s, i) => s.addEventListener('click', (e) => {
        if (i !== this.index) {
          e.preventDefault();
          this.go(i);
        }
      }));

      this.track.addEventListener('transitionend', (e) => {
        if (e.target === this.track) this.normalize();
      });

      let startX = null;
      this.track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.stop(); }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
        else this.start();
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      this.onResize = () => this.update(false);
      window.addEventListener('resize', this.onResize);
      this.update(false);
      this.start();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.stop();
    }

    start() {
      const sec = parseFloat(this.dataset.autoplay || '0');
      this.stop();
      if (sec > 0 && !document.hidden) this.timer = setInterval(() => this.go(this.index + 1, true), sec * 1000);
    }

    stop() {
      clearInterval(this.timer);
    }

    go(i, fromTimer) {
      this.index = i;
      this.update(true);
      // transitionend が来ない環境（裏タブ等）でも複製に取り残されないように
      clearTimeout(this.fix);
      this.fix = setTimeout(() => this.normalize(), 800);
      if (!fromTimer) this.start();
    }

    normalize() {
      if (this.index >= this.C + this.n) {
        this.index -= this.n;
        this.update(false);
      } else if (this.index < this.C) {
        this.index += this.n;
        this.update(false);
      }
    }

    update(animate) {
      const t = this.track;
      if (!animate) t.style.transition = 'none';
      const w = this.slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(t).columnGap) || 0;
      const offset = (t.clientWidth - w) / 2 - this.index * (w + gap);
      t.style.transform = `translateX(${offset}px)`;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
      const real = (((this.index - this.C) % this.n) + this.n) % this.n;
      this.dots.forEach((d, i) => d.setAttribute('aria-current', String(i === real)));
      if (!animate) {
        void t.offsetWidth;
        t.style.transition = '';
      }
    }
  }
  customElements.define('rb-hero-slider', RbHeroSlider);
}
